import {Injectable} from '@angular/core';
import {HttpClientService} from './httpClient.service';
import {InstituicaoEnsino} from '../model/instituicaoEnsino.model';
import {Local} from '../model/local.model';
import {ImagemEnviada} from '../model/imagemEnviada.model';
import {Agendamento} from '../model/agendamento.model';
import {Result} from '../model/result.model';
import {Data} from '../model/data.model';
import {LinhaOnibus} from '../model/linhaOnibus.model';
import {map} from 'rxjs/operators';
import {ConfigurationService} from './configuration.service';
import {Frete} from '../model/frete.model';
import {Ip} from "../model/ip.model";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {LogData} from "../model/logData.model";
import {PendingData} from "../model/pendingData.model";

@Injectable()
export class AgendamentoService {
  apiUrl: string;

  private httpOptions : any;

  constructor(
    private http: HttpClientService,
    private client: HttpClient,
    private configService: ConfigurationService
  ) {
    this.onConfigLoad = this.onConfigLoad.bind(this);
    configService.loadConfigurations().subscribe(this.onConfigLoad);
  }

  getInstituicaoEnsino(agenciaId: Number, search: String) {
    const cookie = JSON.parse(localStorage.getItem('cookie'));
    this.getAuthToken();
    return this.http.get<InstituicaoEnsino[]>(`${this.apiUrl}/back/integracao/instituicaoEnsino?cookie=` + cookie + '&agenciaId=' + agenciaId + '&search=' + search, this.httpOptions).pipe(map(response => response));
  }

  getLinhaOnibus(agenciaId, search) {
    const cookie = JSON.parse(localStorage.getItem('cookie'));
    this.getAuthToken();
    return this.http.get<LinhaOnibus[]>(`${this.apiUrl}/back/integracao/linhas?cookie=` + cookie + '&agenciaId=' + agenciaId + '&search=' + search, this.httpOptions).pipe(map(response => response));
  }

  getLocal(agenciaId, tipoServicoId) {
    const cookie = JSON.parse(localStorage.getItem('cookie'));
    this.getAuthToken();
    return this.http.get<Local[]>(`${this.apiUrl}/back/integracao/local?cookie=` + cookie + '&agenciaId=' + agenciaId + '&tipoServicoId=' + tipoServicoId, this.httpOptions).pipe(map(response => response));
  }

  getData(agenciaId, serviceId, tipoServicoId, localId) {
    const cookie = JSON.parse(localStorage.getItem('cookie'));
    this.getAuthToken();
    return this.http.get<Data[]>(`${this.apiUrl}/back/integracao/datas/v1?cookie=` + cookie + '&agenciaId=' + agenciaId + '&serviceId=' + serviceId + '&tipoServicoId=' + tipoServicoId + '&localId=' + localId, this.httpOptions).pipe(map(response => response));
  }

  getProtocols(agenciaId,page) {
    const cookie = JSON.parse(localStorage.getItem('cookie'));
    this.getAuthToken();
    return this.http.get<Agendamento[]>(`${this.apiUrl}/back/integracao/protocols?cookie=` + cookie + '&agenciaId=' + agenciaId + '&page=' + page, this.httpOptions).pipe(map(response => response)).pipe(map(response => response));
  }

  enviaImagem(agenciaId, cpf, mimeType, tipoDocumento, imagem) {
    const cookie = JSON.parse(localStorage.getItem('cookie'));
    return this.client.post<ImagemEnviada>(`${this.apiUrl}/back/integracao/imagens?cookie=` + cookie + '&agenciaId=' + agenciaId + '&tipoDocumento=' + tipoDocumento + '&cpf=' + cpf + '&mimeType=' + mimeType, imagem, {
      responseType: "json",
      reportProgress: true,
      observe: "events",
      headers: new HttpHeaders({'Content-Type': 'application/json', "Authorization": `Bearer ${localStorage.getItem('authToken').toString().replace('"', '')}`})
    });
  }

  enviaPlanilha(agenciaId, cpf, mimeType, tipoDocumento, planilha) {
    const cookie = JSON.parse(localStorage.getItem('cookie'));
    let formData = new FormData();
    formData.append("file", planilha);
    this.getAuthToken();
    let url = `${this.apiUrl}/back/integracao/upload/sheet?cookie=` + cookie + '&agenciaId=' + agenciaId + '&tipoDocumento=' + tipoDocumento + '&cpf=' + cpf + '&mimeType=' + mimeType;
    return this.http.post<ImagemEnviada>(url, formData, this.httpOptions).pipe(map(response => response));
  }

  postValid(agendamento: Agendamento) {
    const cookie = JSON.parse(localStorage.getItem('cookie'));
    return this.http.post<Result>(`${this.apiUrl}/back/integracao/valid?cookie=` + cookie, JSON.stringify(agendamento), {'Content-Type': 'application/json', "Authorization": `Bearer ${localStorage.getItem('authToken').toString().replace('"', '')}`}).pipe(map(response => response));
  }

  postAgendamento(dadosAgendamento: Agendamento) {
    const cookie = JSON.parse(localStorage.getItem('cookie'));
    return this.http.post<Result>(`${this.apiUrl}/back/integracao/agendamento?cookie=` + cookie, JSON.stringify(dadosAgendamento), {'Content-Type': 'application/json', "Authorization": `Bearer ${localStorage.getItem('authToken').toString().replace('"', '')}`}).pipe(map(response => response));
  }

  getRequireSocialName(agendamentoId : string) {
    const cookie = JSON.parse(localStorage.getItem('cookie'));
    this.getAuthToken();
    return this.http.get<Result>(`${this.apiUrl}/back/integracao/is-require-social-name?cookie=` + cookie + '&protocolId=' + agendamentoId , this.httpOptions).pipe(map(response => response)).pipe(map(response => response));
  }

  postSolicitacao(dadosAgendamento: Agendamento) {
    const cookie = JSON.parse(localStorage.getItem('cookie'));
    return this.http.post<Result>(`${this.apiUrl}/back/integracao/solicitacao?cookie=` + cookie, JSON.stringify(dadosAgendamento), {'Content-Type': 'application/json', "Authorization": `Bearer ${localStorage.getItem('authToken').toString().replace('"', '')}`}).pipe(map(response => response));
  }

  deleteCancelaAgendamento(agenciaId, protocolo) {
    const cookie = JSON.parse(localStorage.getItem('cookie'));
    this.getAuthToken();
    return this.http.delete<Result>(`${this.apiUrl}/back/integracao/cancelar?cookie=` + cookie + '&agenciaId=' + agenciaId + '&protocolo=' + protocolo, this.httpOptions).pipe(map(response => response)).pipe(map(response => response));
  }

  editAgendamento(cpf, agenciaId, protocolo, pendingDataList) {
    const cookie = JSON.parse(localStorage.getItem('cookie'));
    return this.http.post<Result>(`${this.apiUrl}/back/integracao/edit?cookie=` + cookie + '&cpf=' + cpf + '&agenciaId=' + agenciaId + '&protocolo=' + protocolo, JSON.stringify(pendingDataList), {'Content-Type': 'application/json', "Authorization": `Bearer ${localStorage.getItem('authToken').toString().replace('"', '')}`}).pipe(map(response => response)).pipe(map(response => response));
  }

  getLocalRetirada(agenciaId, servicoId, tipoServicoId) {
    const cookie = JSON.parse(localStorage.getItem('cookie'));
    this.getAuthToken();
    return this.http.get<Local[]>(`${this.apiUrl}/back/integracao/localRetirada?cookie=` + cookie + '&agenciaId=' + agenciaId + '&servicoId=' + servicoId + '&tipoServicoId=' + tipoServicoId, this.httpOptions).pipe(map(response => response));
  }

  getFrete(agenciaId, servicoId, tipoServicoId) {
    const cookie = JSON.parse(localStorage.getItem('cookie'));
    this.getAuthToken();
    return this.http.get<Frete[]>(`${this.apiUrl}/back/integracao/frete?cookie=` + cookie + '&agenciaId=' + agenciaId + '&servicoId=' + servicoId + '&tipoServicoId=' + tipoServicoId, this.httpOptions).pipe(map(response => response));
  }

  getIp() {
    return this.http.get<Ip>("https://api.ipify.org?format=json").pipe(map(ip => ip.ip));
  }

  getLog(protocol) {
    const cookie = JSON.parse(localStorage.getItem('cookie'));
    this.getAuthToken();
    return this.http.get<LogData[]>(`${this.apiUrl}/back/integracao/log?cookie=` + cookie + '&protocol=' + protocol, this.httpOptions).pipe(map(response => response)).pipe(map(response => response));
  }

  getPending(protocol) {
    const cookie = JSON.parse(localStorage.getItem('cookie'));
    this.getAuthToken();
    return this.http.get<PendingData[]>(`${this.apiUrl}/back/integracao/pending?cookie=` + cookie + '&protocol=' + protocol, this.httpOptions).pipe(map(response => response)).pipe(map(response => response));
  }

  private onConfigLoad(config) {
    this.apiUrl = config.apiUrl;
  }

  private getAuthToken(){
    this.httpOptions = { "Authorization": `Bearer ${localStorage.getItem('authToken').toString().replace('"', '')}` };
  }
}
